import React from "react";
import SntDialog from "../../SntDialog/SntDialog";
import SntSortZA from "@icons/SntSortZA";
import SntSortAZ from "@icons/SntSortAZ";
import styled from "styled-components";
import SntUnGroup from "@icons/SntUnGroup";
import SntGroupBy from "@icons/SntGroupBy";

import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import { useHasFeature } from "@/hooks/useFeatures";
import { FeatureKey } from "@/types/generated/FeatureKey";

const Styles = styled.div`
  .sortIcon {
    color: grey;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #eff3f4;
  }

  .sortIconHover {
    display: none;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #eff3f4;
  }

  .group-header-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #eff3f4;
  }
`;

interface ColumnHeader {
  key: string;
  columnKey: string;
  description?: string;
  isGrouped?: boolean;
  isSorted?: boolean;
  isSortedDesc?: boolean;
  disableSortBy?: boolean;
  disabledGroupColumn?: boolean;
  getSortByToggleProps: (props?: Record<string, unknown>) => Record<string, unknown>;
  render: (type: string) => React.ReactNode;
}

interface DataFilter {
  toggleGroupColumnKey: (key: string) => void;
}

interface MobileSortingDiaglogProps {
  headers: ColumnHeader[];
  show: boolean;
  setShowMobileSorting: (show: boolean) => void;
  toggleSortBy: (columnId: string, descending?: boolean) => void;
  features?: Record<string, unknown>;
  isDisabbledGroup: boolean;
  dataFilter: DataFilter;
}

const MobileSortingDiaglog = ({
  headers,
  show,
  setShowMobileSorting,
  toggleSortBy,
  isDisabbledGroup,
  dataFilter,
}: MobileSortingDiaglogProps) => {
  
  const hasSearchAggregate = useHasFeature(FeatureKey.search_aggregate);

  return (
    <SntDialog
      isShow={show}
      isShowSaveButton={false}
      onClose={() => setShowMobileSorting(false)}
      title={translate(LanguageKey.sorting_settings)}
    >
      {() => (
        <ul className="ps-0">
          {headers.map((column, index) => {
            return (
              <li className="list-group mb-1" key={index}>
                <Styles>
                  <label className="fw-bold list-group-item">
                    <div className="d-flex align-items-center">
                      <div
                        {...column.getSortByToggleProps({
                          title: column.description,
                        })}
                        onClick={() => {
                          toggleSortBy(
                            column.columnKey,
                            column.isSorted
                              ? !column.isSortedDesc
                              : column.isSortedDesc
                          );
                        }}
                      >
                        {column.isGrouped && (
                          <span style={{ fontWeight: "normal" }}>
                            {translate(LanguageKey.group_by_key)}:{" "}
                          </span>
                        )}
                        {column.render("Header")}
                      </div>

                      {!column.disableSortBy && (
                        <div
                          className="ms-2"
                          {...column.getSortByToggleProps({
                            title: column.description,
                          })}
                          onClick={() => {
                            toggleSortBy(
                              column.columnKey,
                              column.isSorted
                                ? !column.isSortedDesc
                                : column.isSortedDesc
                            );
                          }}
                        >
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <span className="sortIcon">
                                <SntSortZA />
                              </span>
                            ) : (
                              <span className="sortIcon">
                                <SntSortAZ />
                              </span>
                            )
                          ) : (
                            <span className="sortIconHover">
                              <SntSortAZ />
                            </span>
                          )}
                        </div>
                      )}

                      {hasSearchAggregate &&
                        !isDisabbledGroup &&
                        !column.disabledGroupColumn && (
                          <>
                            {column.isGrouped ? (
                              <div
                                className="ms-2"
                                style={{ cursor: "pointer" }}
                              >
                                <span
                                  className="group-header-icon"
                                  title={translate(LanguageKey.ungroup_column_key)}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    dataFilter.toggleGroupColumnKey(column.key);
                                  }}
                                >
                                  <SntUnGroup />
                                </span>
                              </div>
                            ) : (
                              column.isGrouped !== false && (
                                <div
                                  className="ms-2"
                                  style={{ cursor: "pointer" }}
                                >
                                  <span
                                    className="group-header-icon"
                                    title={translate(LanguageKey.group_column_key)}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      dataFilter.toggleGroupColumnKey(
                                        column.key
                                      );
                                    }}
                                  >
                                    <SntGroupBy />
                                  </span>
                                </div>
                              )
                            )}
                          </>
                        )}
                    </div>
                  </label>
                </Styles>
              </li>
            );
          })}
        </ul>
      )}
    </SntDialog>
  );
};

export default MobileSortingDiaglog;
